<template>

<v-main >
   <!-- <v-container fluid> -->
<v-slide-y-reverse-transition >
      <router-view v-show="show" :buscador="buscador" :categoriaSeleccionada="categoriaSeleccionada"
      
       :vendedorSeleccionado="vendedorSeleccionado"

      />
</v-slide-y-reverse-transition>
   <!-- </v-container> -->
</v-main>
</template>

<script>
export default {
  created() {
    this.show = true;
  },
  props: {
    buscador: {
      type: String,
      default: ""
    },
    categoriaSeleccionada: {
      type: String,
      default: "todos"
    }
    ,
    vendedorSeleccionado: {
    type: [String, Number],
      default: 'all'
    }
  }
};
</script>



